const routes = [
    {
        path: "/coop/business-point",
        component: () => import("../pages/Index.vue"),
        meta: {
            isAuthenticated: true
        }
    },
    {
        path: "/coop/business-point/:id/participants",
        component: () => import("../pages/Participants.vue"),
        meta: {
            isAuthenticated: true
        }
    }
];

export default routes;
